<template>
  <ClientOnly>
    <div class="flex h-full flex-col items-start">
      <template v-if="videoUrl">
        <!--
          読込前の skeleton のみ暫定アスペクト比(SP 4:5 / PC 16:9)で場所を確保する。
          動画自体は VideoPlayer 側で実比率(height: auto)のまま表示する（固定枠に押し込まない）。
        -->
        <MoleculesWabunkaSkeltonText v-if="isLoading" :class="`w-full ${aspectClass}`" />
        <!-- 最適化(format/リサイズ)・遅延ロードは OptimizedVideoPlayer が担当。幅のみ SP/PC で出し分ける（動画ソース自体の出し分けは親）。 -->
        <OptimizedVideoPlayer
          v-show="!isLoading"
          class="w-full"
          :on-load-error="handleVideoLoaded"
          :on-loaded="handleVideoLoaded"
          :optimized-video-options="{ width: isSP ? VIDEO_WIDTH_SP : VIDEO_WIDTH_PC }"
          :video-url="videoUrl"
        />
      </template>
    </div>
  </ClientOnly>
</template>

<script setup lang="ts">
import { useIsSP } from '@/wabunka-src/common/composables';
import OptimizedVideoPlayer from '@/wabunka-src/common/features/Featured/components/OptimizedVideoPlayer/OptimizedVideoPlayer.vue';

interface Props {
  /**
   * 再生する動画のURL
   */
  videoUrl: string;
}

defineProps<Props>();

// 当コンポーネントは ClientOnly 配下のため isSP は確定値。動画の最適化幅を SP/PC で出し分ける。
const VIDEO_WIDTH_SP = 720;
const VIDEO_WIDTH_PC = 1280;

const isSP = useIsSP();
const isLoading = ref<boolean>(true);
const aspectClass = computed(() => (isSP.value ? 'aspect-[4/5]' : 'aspect-[16/9]'));

// 読込解除は on-loaded 経由。遅延ロード失敗時(on-load-error)も同じく解除して
// スケルトンが残り続けないようにする。
const handleVideoLoaded = () => {
  isLoading.value = false;
};
</script>
